function openSizeChartModal() {
  document.getElementById('sizeChartModal').style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeSizeChartModal() {
  document.getElementById('sizeChartModal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

window.onclick = function(event) {
  const modal = document.getElementById('sizeChartModal');
  if (event.target == modal) {
    closeSizeChartModal();
  }
}

let currentSlide = 0;

function showSlide(n) {
  const slides = document.querySelectorAll('.carousel-slide');
  if (n >= slides.length) currentSlide = 0;
  if (n < 0) currentSlide = slides.length - 1;
  
  slides.forEach(slide => slide.classList.remove('active'));
  slides[currentSlide].classList.add('active');
}

function nextSlide() {
  currentSlide++;
  showSlide(currentSlide);
}

function prevSlide() {
  currentSlide--;
  showSlide(currentSlide);
}

